import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"base-layout"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }